<template>
  <div class="layout">
    <div class="top"></div>
    <div class="body">
      <slot></slot>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  components: {}
}
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  background-color: #f2f2f2;
  .top {
    flex: 1;
  }
  .bottom {
    flex: 2;
  }
  .body {
    flex: 0 0 auto;
    width: 450px;
    height: 512px;
    box-shadow: 0 2px 20px 4px rgba(192, 196, 204, 0.3);
    border-radius: 10px;
    background-color: #fff;
    padding: 64px;
    box-sizing: border-box;
    position: relative;
  }
  ::v-deep {
    .main-btn {
      box-shadow: 0px 2px 8px 1px rgba(25, 137, 250, 0.3);
      border-radius: 6px;
      margin-top: 36px !important;
    }
    .big-btn {
      width: 100%;
      height: 42px;
      margin-top: 22px;
      font-size: 16px;
      margin-left: 0;
    }
    .custom-input {
      .el-input {
        display: inline-block;
        height: 42px;

        input {
          background: transparent;
          -webkit-appearance: none;
          padding: 12px 5px 12px 35px;
          height: 42px;

          &:-webkit-autofill {
            box-shadow: 0 0 0 1000px #fff inset !important;
          }
        }
      }
    }
  }
}
</style>
